<template>
  <header :class="['header', 'panel', _isMobile() ? 'mobile' : '']">
    <template>
      <div class="menuTitle">
        <a-row style="height: 100%;">
          <a-col :xs="{ span: imageSapn, offset: 2 }" :sm="12" :md="8" :lg="8" :xl="4">
            <img @click="$router.push({path:'/index'})" src="../assets/image/logo.png" style="cursor: pointer; width: 100%;margin-top: 30px;" alt="">
            <p class="title-tips">选中职星 在线学习更轻松</p>
          </a-col>
        </a-row>
      </div>
    </template>
  </header>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { jumpMixins } from "@/utils/jumpMixins"
export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data() {
    return {
      menuActive: '首页',
      imageSapn: 20
    };
  },
  watch: {
    '$route'(to, from) {
      this.menuActive = to.meta.title
      if (to.meta.index == 2) {
        this.imageSapn = 14
      } else {
        this.imageSapn = 20
      }
    },
  },
  created() {
    this.imageSapn = this.$route.meta.index == 2 ? 14 : 20
    this.menuActive = this.$route.meta.title
  },

  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>
<style lang="scss">
@import url(../assets/index.scss);
@import '~@assets/iconfont.css';
</style>
<style lang="less" scoped>
.menuTitle {
  width: 100%;
  height: 203px;
  background: #F75250;

  .title-tips {
    width: 100%;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-size: 13px;
    font-weight: bold;
    margin-top: 10px;
    letter-spacing: 3px;
  }
}
</style>